import(/* webpackMode: "eager" */ "/home/chungbn/web_game/prod/app/page.tsx");
